const LiturgicalSeasons = {
  "ADVENT": "Advent",
  "CHRISTMASTIDE": "Christmastide",
  "EARLY_ORDINARY_TIME": "Early Ordinary Time",
  "LATER_ORDINARY_TIME": "Later Ordinary Time",
  "LENT": "Lent",
  "HOLY_WEEK": "Holy Week",
  "EASTER": "Easter"
};
export default LiturgicalSeasons;
